import { DropDownItem } from "app/components";
import { AlertService } from "app/services";
import { GetUserParameter, PageModel, SalesService, UserAuth, UserForSalesManagement } from "app/services/sales.service";
import { SalesManager } from "app/services/sales/model/SalesManager";
import { Subject, Subscription } from "rxjs";
import { MailFormComponentViewModel } from "./modal/mail-form.viewmodel";
import { MailHistoryModalComponentViewModel } from "./modal/mail-history-modal.viewmodel";
import { MessageModalComponentViewModel } from "./modal/message-modal.viewmodel";
import { UserInfoModalComponentViewModel } from "./modal/user-info-modal.viewmodel";
import { NewUserListGridViewModel } from "./new-user-list.viewmodel.grid";

export class NewUserListViewModel {

  public JobTpItems: DropDownItem<string>[] = [
    new DropDownItem<string>("직업 구분(전체)", null),
    new DropDownItem<string>("화주", "0"),
    new DropDownItem<string>("포워더", "1"),
    new DropDownItem<string>("선사", "2"),
    new DropDownItem<string>("기타", "99")
  ];


  public UserStatusItems: DropDownItem<number>[] = [
    new DropDownItem<number>("가입상태(전체)", null),
    new DropDownItem<number>("정상가입", 1),
    new DropDownItem<number>("임시가입", 2),
    new DropDownItem<number>("탈퇴", -1)
  ];

  public SalesManagerItems: DropDownItem<number>[] = [
    new DropDownItem<number>("영업 담당자(전체)", null)
  ];

  public addSalesManagers(salesManagers: SalesManager[]) {
    if (salesManagers) {
      salesManagers.forEach(salesManager => {
        let dropDownItem: DropDownItem<number> = new DropDownItem(salesManager.fullName, salesManager.userId);
        this.SalesManagerItems.push(dropDownItem);
      });
      
      this.gridViewModel.salesManagersDropdownItems = this.SalesManagerItems;
    }
  }

  public LingoAuthItems: DropDownItem<number>[] = [
    new DropDownItem<number>("링고 상태(전체)", null),
    new DropDownItem<number>("미요청", 0),
    new DropDownItem<number>("요청", 1),
    new DropDownItem<number>("요청 승인 완료", 2),
    new DropDownItem<number>("최종 승인 완료", 3),
    new DropDownItem<number>("거절", 99)
  ];



  public selectedJobTp: string;
  public selectedUserStatusCd: number;
  public selectedSalesManagerUserId: number;
  public selectedLingoAuthStatusCd: number;
  public queryText: string;

  public pageNo: number = 1;
  public pageCount: number = 0;
  public pages: number[] = [];
  public userCount: number = 0;

  public users: UserForSalesManagement[] = null;
  public getUserSubscription: Subscription;
  public getUserAuthSubscription: Subscription;

  public gridViewModel: NewUserListGridViewModel;
  public userInfoModalViewModel: UserInfoModalComponentViewModel = new UserInfoModalComponentViewModel();
  public messageModalViewModel: MessageModalComponentViewModel;
  public mailFormViewModel: MailFormComponentViewModel;

  public mailHistoryModalViewModel: MailHistoryModalComponentViewModel;

  public selectedUser: UserForSalesManagement;
  public selectedUserAuth: UserAuth;
  

  private onMessageModifiedCallback = () => {
    let user: UserForSalesManagement = this.findUser(this.messageModalViewModel.user.userId);
    if (user != null) {
      user.hasMessage = (this.messageModalViewModel.messages.length > 0);
    }
    this.gridViewModel.rowDataChanged(user);
  }

  private refreshUser(userId: number) {
    this.salesService.getUser(
      userId,
      (u: UserForSalesManagement) => {
        let userIndex = this.users.findIndex((v) => v.userId === u.userId);
        if (userIndex >= 0) {
          this.users[userIndex] = u;
        }
        this.gridViewModel.rowDataChanged(u);
      }
    );
  }



  private confirmButtonClickCallback = (userId: number, salesStatusCode: string, salesManagerUserId: number) => {
    this.salesService.confirm(
      userId,
      salesStatusCode,
      salesManagerUserId,
      () => {
        this.refreshUser(userId);
      },
      (error) => {
        this.alertService.error(error);
      }
    );
  }

  private completeButtonClickCallback = (userId: number, salesManagerUserId: number) => {
    this.salesService.putUserSalesStatus(
      userId,
      '0',
      salesManagerUserId,
      () => {
        this.refreshUser(userId);
      },
      (error) => {
        this.alertService.error(error);
      }
    );
  }

  private deleteButtonClickCallback = (userId: number) => {
    this.salesService.deleteUserSalesStatus (
      userId,
      () => {
        this.refreshUser(userId);
      },
      (error) => {
        this.alertService.error(error);
      }
    );
  }

  private openMailFormButtonClickCallback = (user: UserForSalesManagement) => {
    this.mailFormViewModel = new MailFormComponentViewModel(this.salesService, this.alertService); 
    this.mailFormViewModel.open(user);
  }

  private openMailHistoryButtonClickCallback = (user: UserForSalesManagement) => {
    this.mailHistoryModalViewModel = new MailHistoryModalComponentViewModel(this.salesService, this.alertService);
    this.mailHistoryModalViewModel.open(user);
  }

  constructor(private salesService: SalesService, private alertService: AlertService) {
    this.gridViewModel = new NewUserListGridViewModel();
    this.gridViewModel.messageButtonClickCallback = (user: UserForSalesManagement) => {this.messageModalViewModel.open(user)}
    this.gridViewModel.confirmButtonClickCallback = this.confirmButtonClickCallback;
    this.gridViewModel.completeButtonClickCallback = this.completeButtonClickCallback;
    this.gridViewModel.deleteButtonClickCallback = this.deleteButtonClickCallback;
    this.gridViewModel.openMailFormButtonClickCallback = this.openMailFormButtonClickCallback;
    this.gridViewModel.openMailHistoryButtonClickCallback = this.openMailHistoryButtonClickCallback;

    this.messageModalViewModel = new MessageModalComponentViewModel(salesService, alertService);
    this.messageModalViewModel.onMessageModifiedCallback = this.onMessageModifiedCallback;

    this.mailFormViewModel = new MailFormComponentViewModel(salesService, alertService);

    this.mailHistoryModalViewModel = new MailHistoryModalComponentViewModel(this.salesService, this.alertService);
    
    this.getSalseManager();
    this.getUsers();    
  }

  destroy() {

    if (this.getUserSubscription) {
      this.getUserSubscription.unsubscribe();
    }

    if (this.getUserAuthSubscription) {
      this.getUserAuthSubscription.unsubscribe();
    }
  }


  public getSalseManager(callback?: (managers: SalesManager[]) => void) {

    this.salesService.getSaleManagers((managerObjects: Object[]) => {
      if (!managerObjects) {
        return;
      }

      let managers = managerObjects.map(o => new SalesManager(o));
      this.addSalesManagers(managers);

      if (callback) {
        callback(managers);
      }
    });
  }


  public setUserAuth(userId: number, callback?: (userAuth: UserAuth) => void) {
    if (this.getUserAuthSubscription) {
      this.getUserAuthSubscription.unsubscribe();
    }

    this.salesService.getUserAuth(userId, (value: UserAuth) => {
      this.selectedUserAuth = value;
      if (callback) {
        callback(value);
      }
    });
  }


  private get getUserParameter(): GetUserParameter {
    let parameter: GetUserParameter = new GetUserParameter();

    parameter.page = this.pageNo;
    parameter.jobTp = this.selectedJobTp;
    parameter.lingoAuthStatusCd = this.selectedLingoAuthStatusCd;
    parameter.salesManagerUserId = this.selectedSalesManagerUserId;
    parameter.stusCd = this.selectedUserStatusCd;
    parameter.text = this.queryText;

    return parameter;
  }

  public findUser(userId: number): UserForSalesManagement {
    let findUser = null;
    if (!userId || !this.users) {
      return null;
    }
    findUser = this.users.find((value) => {
      if (!value || !value.userId) {
        return false;
      }
      if (value.userId === userId) {
        return true;
      }
    });
    return findUser;
  }

  public getUsers(callback?: (usersPage: PageModel<UserForSalesManagement>) => void) {
    if (this.getUserSubscription) {
      this.getUserSubscription.unsubscribe();
    }

    this.getUserSubscription = this.salesService.getUsers(this.getUserParameter, (usersPage: PageModel<UserForSalesManagement>) => {
      this.pageNo = usersPage.pageNo;
      this.pageCount = usersPage.totalPages;
      this.userCount = usersPage.totalElems;

      this.pages = this.getPages(this.pageNo, this.pageCount);

      this.users = usersPage.datas;
      if (callback) {
        callback(usersPage);
      }
    });
  }

  private getPages(pageNo: number, pageCount: number): number[] {
    let pages: number[] = [];

    let navSize: number = 9;
    let minPageNo: number = Math.max(1, pageNo - (navSize - 1) / 2);
    let maxPageNo: number = Math.min(pageCount, pageNo + (navSize - 1) / 2);

    if (minPageNo === 1) {
      let gap: number = Math.abs(pageNo - (navSize - 1) / 2 - 1);
      maxPageNo = Math.min(pageCount, maxPageNo + gap);
    }

    if (maxPageNo === pageCount) {
      let gap: number = Math.abs(pageNo + (navSize - 1) / 2 - pageCount);
      minPageNo = Math.max(1, minPageNo - gap);
    }

    for (let i: number = minPageNo; i <= maxPageNo; i++) {
      pages.push(i);
    }

    return pages;
  }

  public openUserInfoModal(user: UserForSalesManagement) {
    this.selectedUser = user;
    let userId = this.selectedUser.userId;

    this.setUserAuth(userId, (userAuth) => {
      this.userInfoModalViewModel.user = this.selectedUser;
      this.userInfoModalViewModel.userAuth = this.selectedUserAuth;
      this.userInfoModalViewModel.isOpen = true;
    });

  }

  public patchUserInfo() {
    let user = this.userInfoModalViewModel.user;
    let userModified = this.userInfoModalViewModel.userModified;
    let userAuth = this.userInfoModalViewModel.userAuth;
    let userAuthModified = this.userInfoModalViewModel.userAuthModified;


    if (Object.keys(userModified).length) {
      this.salesService.patchUser(user.userId, userModified, () => {

        for (let i in this.users) {
          if (user.userId === this.users[i].userId) {
            this.users[i] = user;
            this.gridViewModel.rowDataChanged(this.users[i]);
            break;
          }
        }
      });
    }

    if (Object.keys(userAuthModified).length) {
      this.salesService.patchUserAuth(userAuth.userAuthId, userAuthModified);
    }
  }


  public openMessageModal(user: UserForSalesManagement) {
    this.messageModalViewModel.open(user);
  }


}





// WEBPACK FOOTER //
// ./src/app/containers/user/new-user-list.viewmodel.ts